module.exports = __webpack_public_path__ + "images/category_lp/common/icon-satei@2x_e6703de7ee12ee91933bcfd3c68cea8d.png";